module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- <p>\nמאז ' +
((__t = ( up_or_down(net_allocated,net_revised) )) == null ? '' : __t) +
'\n ב- ' +
((__t = ( format_number(net_revised - net_allocated) )) == null ? '' : __t) +
'\n  ל- ' +
((__t = ( format_number(net_revised) )) == null ? '' : __t) +
'. ' +
((__t = ( increase_or_cut(net_allocated,net_revised) )) == null ? '' : __t) +
' מהווה שינוי של  ' +
((__t = ( parseInt(Math.abs(1 - (net_revised/net_allocated)) * 100) )) == null ? '' : __t) +
' %.\n<br/>\nסכום זה הועבר ב-  ' +
((__t = ( num_of_transfers_in_year_text(year) )) == null ? '' : __t) +
'.\n</p> -->\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/header__changed_this_year.html
// module id = 135
// module chunks = 0